import { useQuery } from '@tanstack/react-query'
import { useOutletContext } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import MissionSetupTabs from '@App/components/MissionSetupTabs/MissionSetupTabs'
import DataSectionTitle from '@App/components/DataSectionTitle/DataSectionTitle'
import TrapsToggles from '@App/components/TrapsToggles/TrapsToggles'
import TypeToggles from '@App/components/TypeToggles/TypeToggles'
import SourceToggles from '@App/components/SourceToggles/SourceToggles'
import { fetchMissionDataSourcesByGroup, fetchMissionDataTypesByGroup } from '@services/data.service'
import {
  setSourceActiveNames, setEnvironmentActiveTypeIds, setBreedingSiteActiveTypeIds,
  toggleSmartTrapFilterId,
} from '@App/pages/MissionSetup/mission-setup.slice'

import BreedingSitesData from '../BreedingSites/BreedingSitesData/BreedingSitesData'
import EnvironmentData from '../Environment/EnvironmentData/EnvironmentData'

import SamplingStrategies from './SamplingStrategies/SamplingStrategies'
import AdditionalLayers from './AdditionalLayers/AdditionalLayers'
import TrapsMapLogic from './TrapsMapLogic/TrapsMapLogic'

import './trap-planner.styl'

function TrapPlanner() {
  const dispatch = useDispatch()
  const { map } = useOutletContext()
  const { activeProject, breedingSiteActiveTypeIds, smartTrapFilterIds } = useSelector(state => state.missionSetup)
  const { sourcesActiveNames, environmentActiveTypeIds } = useSelector(state => state.missionSetup)

  const { data: sources } = useQuery({
    queryKey: ['sources', activeProject?.id, 'env'],
    queryFn: () => fetchMissionDataSourcesByGroup(activeProject?.id, 'env'),
  })

  const { data: types } = useQuery({
    queryKey: ['types', 'env', activeProject?.id],
    queryFn: () => fetchMissionDataTypesByGroup('env', activeProject?.id),
  })

  const { data: breedingTypes } = useQuery({
    queryKey: ['types', 'breeding', activeProject?.id],
    queryFn: () => fetchMissionDataTypesByGroup('breeding', activeProject?.id),
  })

  return (
    <div className="trap-planner">
      <MissionSetupTabs />
      <hr />
      <DataSectionTitle>Guidance for deploying new traps</DataSectionTitle>
      <SamplingStrategies map={map} />
      <DataSectionTitle>Deployed traps</DataSectionTitle>
      <TrapsMapLogic
        map={map}
        smartTrapFilterIds={smartTrapFilterIds}
      />
      <TrapsToggles
        smartTrapFilterIds={smartTrapFilterIds}
        toggleSmartTrapFilterId={id => dispatch(toggleSmartTrapFilterId(id))}
      />
      <AdditionalLayers map={map} />
      <DataSectionTitle>Environment data</DataSectionTitle>
      <TypeToggles
        types={types}
        activeTypeIds={environmentActiveTypeIds}
        setActiveTypeIds={setEnvironmentActiveTypeIds}
        badge={false}
      />
      <DataSectionTitle>Breeding sites</DataSectionTitle>
      <TypeToggles
        types={breedingTypes}
        activeTypeIds={breedingSiteActiveTypeIds}
        setActiveTypeIds={setBreedingSiteActiveTypeIds}
        badgeShape="triangle"
      />
      <DataSectionTitle>Data source</DataSectionTitle>
      <SourceToggles
        sources={sources}
        sourcesActiveNames={sourcesActiveNames}
        setSourceActiveNames={setSourceActiveNames}
      />
      <BreedingSitesData passive />
      <EnvironmentData passive />
    </div>
  )
}

export default TrapPlanner
